import { render, staticRenderFns } from "./slidingText.vue?vue&type=template&id=04920428"
import script from "./slidingText.vue?vue&type=script&lang=js"
export * from "./slidingText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MarqueeText: require('/vercel/path0/components/ui/marqueeText.vue').default})
